const features = [
  {
    icon: 'ri-database-2-line',
    title: '海量吃瓜资源',
    desc: '聚合全网热门爆料事件完整录像，涵盖娱乐圈八卦、社会热点、网红争议与综艺名场面，打造一站式91吃瓜视频在线观看合集。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速高清播放',
    desc: '支持91吃瓜在线播放与高清流畅体验，即点即看无需等待。多线路智能切换，确保91吃瓜视频在线观看稳定不卡顿。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日实时更新',
    desc: '编辑团队全天候追踪热点，每天入库50+最新吃瓜视频资源，让你第一时间吃到最新鲜的瓜，热点事件绝不遗漏。',
  },
];

export default function FeaturesAboutSection() {
  return (
    <>
      <section id="features" className="relative py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              为什么选择我们
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              专注吃瓜视频领域，为瓜友提供最优质的观看体验
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {features.map((item, idx) => (
              <div
                key={idx}
                className="group relative bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-7 hover:border-primary-200 transition-all duration-300 cursor-default"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                  <i className={`${item.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="about" className="relative py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 w-full">
              <div className="relative w-full max-w-[520px] mx-auto aspect-[4/3] rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimal%20workspace%20with%20multiple%20screens%20displaying%20entertainment%20content%2C%20warm%20coral%20and%20cream%20interior%20design%2C%20editorial%20newsroom%20atmosphere%2C%20soft%20natural%20lighting%20through%20large%20windows%2C%20clean%20professional%20aesthetic%2C%20comfortable%20creative%20environment%20with%20plants&width=800&height=600&seq=91crab-about-01&orientation=landscape"
                  alt="91吃瓜爆料网 - 关于我们"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.display = 'none';
                    }
                  }}
                />
              </div>
            </div>
            <div className="flex-1 w-full text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
                关于91吃瓜爆料网
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                91吃瓜爆料网成立于2024年，是国内领先的吃瓜视频聚合平台。我们致力于为瓜友提供最新、最全、最高清的吃瓜视频在线观看体验。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                平台内容覆盖娱乐圈明星八卦、社会热点事件追踪、网红达人争议实录、综艺节目名场面回顾等多个维度。我们的编辑团队7×24小时追踪全网热点，确保每一条值得关注的爆料都能第一时间呈现给用户。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                无论你是资深吃瓜群众还是偶尔刷瓜的路人，91吃瓜爆料网都能满足你随时随地在线观看吃瓜视频的需求。支持91吃瓜在线播放与91吃瓜视频在线观看，高清流畅即点即看。
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}